class ReportService {
  reportTitles(data, titles, action) {
    return $.post(reportTitlesUrl, {
      dataArr: data,
      titles,
      action
    });
  }

  reportEdit(data) {
    return $.post(saveReportEdit, data);
  }
}

module.exports = ReportService;
